import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS } from "library/shared";
import { useMutation } from "react-query";
import api from "service/api";
import { useInvalidateBenefitCategories } from "./useGetBenefitCategories";

type Params = {
  countryCode: number | string;
  benefitCategoryTag: number | string;
  clientInternalNumberGOS: number | string;
  rowVersion: string;
};

const deleteCategory = async ({
  countryCode,
  clientInternalNumberGOS,
  benefitCategoryTag,
  rowVersion,
}: Params) => {
  const response = await api.patch(
    `/benefitcategory/delete/${countryCode}/${clientInternalNumberGOS}/${benefitCategoryTag}`,
    {
      rowVersion,
    }
  );
  return response.data;
};

export function useDeleteBenefitCategory(refetch = true) {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateBenefitCategories = useInvalidateBenefitCategories();
  return useMutation(deleteCategory, {
    mutationKey: MUTATION_KEYS.deleteBenefitCategory,
    onSuccess: () => {
      if (refetch) {
        invalidateBenefitCategories();
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
